import { apiClient } from '../../../../helpers/apiHelperV2';
import { shouldFetch } from '../../../fetchStatus';
import { standortUrlSelector } from '../../../selectors/url';
import {
    FETCH_SERVICE_ANGEBOTE_FAILURE,
    FETCH_SERVICE_ANGEBOTE_REQUEST,
    FETCH_SERVICE_ANGEBOTE_SUCCESS,
    SET_SERVICE_ANGEBOTE_FILTER_VALUES,
} from '../../../actionTypes';
import { serviceAngeboteResponseSelector } from '../../../selectors/standort/service/serviceAngebote';

export const fetchServiceAngeboteIfNeeded = ({ serviceUrl }) => {
    return async function (dispatch, getState) {
        if (!serviceUrl) return;

        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const serviceAngeboteResponse = serviceAngeboteResponseSelector(state, { serviceUrl });

        if (shouldFetch(serviceAngeboteResponse.status)) {
            dispatch({
                type: FETCH_SERVICE_ANGEBOTE_REQUEST,
                payload: { standortUrl, serviceUrl },
            });
            try {
                const res = await apiClient.get('/api/v1/ServiceAngebote', {
                    params: {
                        standortUrl,
                        serviceUrl,
                    },
                });
                dispatch({
                    type: FETCH_SERVICE_ANGEBOTE_SUCCESS,
                    payload: { standortUrl, serviceUrl, data: res.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_SERVICE_ANGEBOTE_FAILURE,
                    payload: { standortUrl, serviceUrl, error },
                });
            }
        }
    };
};

export const setServiceAngeboteFilterValues = ({ serviceUrl, filterValues }) => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);

        dispatch({
            type: SET_SERVICE_ANGEBOTE_FILTER_VALUES,
            payload: {
                standortUrl,
                serviceUrl,
                filterValues,
            },
        });
    };
};
